import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

// useUrlState reads and writes the query string, which is what says where the page
// is: a link opens the same thing, and the back button walks out of it. Each change
// is folded into what's already there so one part of a page doesn't drop another's.
export function useUrlState() {
    const [params, setParams] = useSearchParams();
    const loc = useLocation();
    const navigate = useNavigate();

    return {
        text: (name: string) => params.get(name) || "",

        // id is 0 when the parameter names nothing
        id: (name: string) => parseInt(params.get(name) || "", 10) || 0,

        // an empty value drops the parameter. replace keeps the change out of the
        // history, for a step the back button shouldn't have to walk through. path
        // moves the page along with the change.
        set: (changes: Record<string, string>, options?: { replace?: boolean; path?: string }) => {
            const apply = (current: URLSearchParams) => {
                const next = new URLSearchParams(current);

                for (const [key, value] of Object.entries(changes)) {
                    if (value) next.set(key, value);
                    else next.delete(key);
                }

                return next;
            };

            if (options?.path && options.path !== loc.pathname) {
                navigate({ pathname: options.path, search: apply(params).toString() }, { replace: options.replace });
                return;
            }

            setParams(apply, { replace: options?.replace });
        },
    };
}
